export default __webpack_public_path__ + "static/media/buywater-logo-blue-min.d058cd1e.png";